module.exports = __webpack_public_path__ + "img/invoice0.befded6b.png";